import React, { useState } from 'react';
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';
import { FaQuestionCircle, FaTrashAlt } from "react-icons/fa";
import { TempSavedValue } from '../types';
import RestoreForm from "../RestoreForm";
import ResetButton from '../ResetButton';

/**
 * ImportingDocumentsFormコンポーネント用のPropsです。
 * @interface ImportingDocumentsFormProps
 */
interface ImportingDocumentsFormProps {

  /**
   * フォームをリストアする関数です。
   * @memberof ImportingDocumentsFormProps
   */
  restoreForm: (jsonObject: TempSavedValue) => void;

  /**
   * フォームをリセットする関数です。
   * @memberof ImportingDocumentsFormProps
   */
  resetForm: () => void;

}

/**
 * 書類情報の取り込みフォームコンポーネントです。
 * @param {function} props.restoreForm - フォームをリストアするコールバック関数
 * @param {function} props.resetForm - フォームをリセットするコールバック関数
 * @returns {JSX.Element} - JSX要素
 */
const ImportingDocumentsForm: React.FC<ImportingDocumentsFormProps> = ({ restoreForm, resetForm }) => {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div className="mb-3 rounded-3 align-baseline" style={{backgroundColor: '#ffe4b5'}}>
        <h3 className="h5 py-2 px-2 text-primary fw-bold">一時保存した書類情報を取り込む</h3>
      </div>
      <Row className="d-flex align-items-center d-grid">
        <Col xs={12}>
          「一時保存」した書類情報を取り込む場合はファイルを指定してください。
        </Col>
        <Col lg={6} xs={12} className="mb-3">
          <RestoreForm onChange={restoreForm} />
        </Col>
        <Col lg={5} xs={9} className="mb-3 d-grid">
          <ResetButton onClick={resetForm} />
        </Col>
        <Col lg={1} xs={3} className="mb-3 text-end">
          <button className="btn btn-link" onClick={handleShow} style={{padding: '0'}}>
            <FaQuestionCircle />
          </button>
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>
                <h4 className="h5">書類情報を取り込む</h4>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="px-2">
                <h5 className="h6">【取り込むことができるファイルの対象】</h5>
                <ul>
                  <li>取り込むことができる一時保存ファイルは、本ツールで一時保存したjsonファイルのみです。</li>
                  <li>PDFファイルやその他のファイルは取り込むことができません。</li>
                </ul>
                <Form.Group
                  controlId="formFile"
                  className="w-100"
                >
                  <Form.Control type="file" style={{pointerEvents: 'none'}} />
                </Form.Group>
                <ul>
                  <li className="my-1">「一時保存」した入力データを、再度、Webフォームに入力したい場合にご利用ください。</li>
                  <li className="my-1">「ファイルを選択」ボタンから、呼び出したいファイル名を選択し、「呼び出し」をクリックすると、Webフォームにデータが入力されます。</li>
                </ul>
                <Button
                  variant="outline-danger"
                  size="sm"
                  className="w-100"
                  style={{pointerEvents: 'none'}}
                >
                  <FaTrashAlt />
                  <span className="ms-1">入力クリア</span>
                </Button>
                <ul>
                  <li className="my-1">作業中の入力データを消去したい場合にご利用ください。</li>
                </ul>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </Col>
      </Row>
    </>
  );
}

export default ImportingDocumentsForm;